import React from 'react'
import { AudioPlayerStyle } from './styled'
import { useTranslation } from 'react-i18next'

const AudioPlayer = props => {
  const { t } = useTranslation()
  return (
    <AudioPlayerStyle>
      {props.autoPlay && (
        <audio
          id="audioId"
          style={{ width: props.width, height: props.height }}
          controls
          autoPlay
          controlsList="nodownload"
          preload="none"
        >
          <source src={props.src} type="audio/mp3" />
          {t('v3:browser_audio_not_support')}
        </audio>
      )}

      {!props.autoPlay && (
        <audio
          id="audioId"
          style={{ width: props.width, height: props.height }}
          controls
          controlsList="nodownload"
          preload="none"
        >
          <source src={props.src} type="audio/mp3" />
          {t('v3:browser_audio_not_support')}
        </audio>
      )}
    </AudioPlayerStyle>
  )
}

export default AudioPlayer
